import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoto = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M465.15 126.16c-9.28-9.89-22.33-16.17-36.89-16.17h-65.75c-2.83 0-5.6-1.04-7.74-2.91L317.58 70.1c-9.42-9.64-22.57-15.12-35.94-15.12h-84.16c-13.59 0-26.3 5.26-35.94 14.9l-36.6 36.82c-2.19 1.97-5.26 3.29-8.33 3.29H50.85C22.8 109.99 0 132.78 0 160.84V373c0 14.75 6.3 27.92 16.22 37.23l18.67 18.63c9.29 9.84 22.37 16.07 36.93 16.07h377.04l.2.1c28.08 0 50.94-22.86 50.94-50.93V181.88c0-14.45-6.12-27.44-15.82-36.72l-19.03-18.99Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fafafb",
			d: "M439.44 160.84V373c0 6.36-5.04 11.62-11.4 11.62H50.85c-6.36 0-11.4-5.04-11.4-11.62V160.84c0-6.36 5.04-11.4 11.4-11.4h65.53c13.59 0 26.52-5.26 36.16-14.9l36.6-36.6c2.19-2.19 5.04-3.51 8.11-3.51h84.16c3.07 0 5.92 1.31 8.11 3.51l36.6 36.6c9.64 9.42 22.57 14.9 36.16 14.9h65.75c6.14 0 11.4 5.04 11.4 11.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fafafb",
			d: "M239.55 175.96c-42.96 0-77.81 34.85-77.81 77.81s34.85 77.81 77.81 77.81 77.81-34.85 77.81-77.81-34.85-77.81-77.81-77.81m0 136.1c-32 0-58.08-26.08-58.08-58.08s26.08-58.3 58.08-58.3 58.08 26.08 58.08 58.3-26.08 58.08-58.08 58.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M239.55 156.23c-53.92 0-97.53 43.83-97.53 97.53s43.61 97.53 97.53 97.53 97.53-43.61 97.53-97.53-43.83-97.53-97.53-97.53m0 155.83c-32 0-58.08-26.08-58.08-58.08s26.08-58.3 58.08-58.3 58.08 26.08 58.08 58.3-26.08 58.08-58.08 58.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fafafb",
			d: "M297.63 253.99c0 32-26.08 58.08-58.08 58.08s-58.08-26.08-58.08-58.08 26.08-58.3 58.08-58.3 58.08 26.08 58.08 58.3"
		})
	]
});
export default SvgPhoto;
